import {createRoot} from 'react-dom/client';
import App from './App';
import Environment from "./config/Environment";
import appData from "../package.json";
import * as Sentry from '@sentry/react';
import './index.css';

const SENTRY_ENABLED_ENVIRONMENTS = ['production', 'staging', 'development'];

Sentry.init({
    enabled: SENTRY_ENABLED_ENVIRONMENTS.includes(Environment.current),
    release: `${appData.name}@${appData.version}`,
    environment: Environment.current,
    dsn: 'https://9e80b3f6639a3ab37743f44011fe7be9@o4505567923404800.ingest.us.sentry.io/4509033393750016',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
        'localhost',
        'https://scan-n-go-16e2e--development-elsyjoo1.web.app/',
        'https://scan-n-go-16e2e--staging-584ul86d.web.app/',
        'https://entel.motiondisplays.com/',
        'https://entel.motiondisplays.cl/'
    ]
});

createRoot(document.getElementById('root')).render(<App/>);